import instance from '../instance'
export default class GlAccounts {
  static getGLAccountByTypes() {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts-aggregate/gl-accounts-by-types`,
      method: 'GET'
    })
  }

  static getGLAccounts(glCategory) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts-aggregate/category/${glCategory}`,
      method: 'GET'
    })
  }

  static getGLAccountsByCategory(glCategory, params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts-aggregate/glaccounts/${glCategory}`,
      method: 'GET',
      params
    })
  }
}
